import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { WEEK, DAY_LABELS, todayKey } from "@/lib/hh";

function Chip({ on, onClick, children, testId, disabled }) {
  return (
    <button data-testid={testId} data-on={on} disabled={disabled} onClick={onClick} className="chip shrink-0 disabled:opacity-40">
      {children}
    </button>
  );
}

export function FiltersBar({ filters, setFilters, count }) {
  const isToday = filters.day === todayKey();
  const set = (k, v) => setFilters((f) => ({ ...f, [k]: v }));
  return (
    <div className="flex flex-col gap-3 md:flex-row md:items-center md:justify-between">
      <div className="no-scrollbar -mx-1 flex items-center gap-2 overflow-x-auto px-1 pb-1">
        <Select value={filters.day} onValueChange={(v) => set("day", v)}>
          <SelectTrigger data-testid="filter-day-select" className="h-9 w-36 shrink-0 rounded-full bg-[#141419]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            {WEEK.map((d) => <SelectItem key={d} value={d}>{d === todayKey() ? `Today (${DAY_LABELS[d].slice(0, 3)})` : DAY_LABELS[d]}</SelectItem>)}
          </SelectContent>
        </Select>
        <Chip testId="filter-open-now" on={filters.openNow} disabled={!isToday} onClick={() => set("openNow", !filters.openNow)}>Open Now</Chip>
        <Chip testId="filter-ending-soon" on={filters.endingSoon} disabled={!isToday} onClick={() => set("endingSoon", !filters.endingSoon)}>Ending Soon</Chip>
        <Chip testId="filter-under-5" on={filters.under5} onClick={() => set("under5", !filters.under5)}>Drinks Under $5</Chip>
      </div>
      <div className="flex items-center gap-3">
        <span data-testid="results-count" className="text-sm text-zinc-500">{count} spots</span>
        <Select value={filters.sort} onValueChange={(v) => set("sort", v)}>
          <SelectTrigger data-testid="sort-select" className="h-9 w-48 rounded-full bg-[#141419]">
            <SelectValue />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="distance">Sort: Closest first</SelectItem>
            <SelectItem value="cheapest">Sort: Cheapest drink</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
